







import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RouteNames } from '@/router'

import type { RawLocation } from 'vue-router'

interface Data {
  activeScriptLink: RawLocation
}

interface Computed {
  hasActiveScript: boolean
  isNotOnActiveScriptPage: boolean
}

export default Vue.extend<Data, {}, Computed, {}>({
  data: () => ({
    activeScriptLink: { name: RouteNames.ActiveScript },
  }),

  computed: {
    ...mapGetters(['hasActiveScript']),
    isNotOnActiveScriptPage(): boolean {
      return (
        this.hasActiveScript && this.$route.name !== RouteNames.ActiveScript
      )
    },
  },
})
